import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArticleView } from '../components/ArticleView';
import { newsStories } from '../data/news';
export function NewsArticle() {
  const {
    slug
  } = useParams();
  const story = newsStories.find(s => s.slug === slug);
  if (!story) {
    return <main className="flex min-h-[70vh] flex-col items-center justify-center bg-paper px-6 text-center" data-id="element-1559" data-mp="1bpdkwrtm0pmp">
        <h1 className="font-editorial text-[40px]" data-id="element-1560" data-mp="e2df0wh48zzl">This story is no longer available.</h1>
        <Link to="/#news" className="mt-6 text-[15px] font-medium" data-id="element-1561" data-mp="izn42b0lf9mw">
          Return to the news →
        </Link>
      </main>;
  }
  return <ArticleView article={story} siblings={newsStories} basePath="/news" backLabel="The News" backHref="/#news" moreHeading="More from the house" data-id="element-1562" data-mp="o1m6nioie2is" />;
}